export default "__VITE_ASSET__30b5dd06__"